import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error ts-migrate(7016) NOFIX
import seperatedCircleIllustration from 'bender-url!../../../images/highlightedMembers/illustrations/seperated-circles.svg'; // @ts-expect-error ts-migrate(7016) NOFIX

import overlappingCircleIllustration from 'bender-url!../../../images/highlightedMembers/illustrations/overlapping-circles.svg'; // @ts-expect-error ts-migrate(7016) NOFIX

import starsIllustration from 'bender-url!../../../images/highlightedMembers/illustrations/stars.svg';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import CUIImage from 'connect-dot-com-ui-components/Components/CUIImage/CUIImage';
import DharmeshShah from './HighlightedMembers/DharmeshShah';
import KieranFlanagan from './HighlightedMembers/KieranFlanagan';
import KyleJepson from './HighlightedMembers/KyleJepson';
import KatherineBoyarsky from './HighlightedMembers/KatherineBoyarsky';
import AliSchwanke from './HighlightedMembers/AliSchwanke';
export default function HomepageMemberHighlightDesktopLayout({
  display
}) {
  return /*#__PURE__*/_jsxs(CUIFlex, {
    gap: 4,
    display: display,
    children: [/*#__PURE__*/_jsxs(CUIFlex, {
      direction: "column",
      gap: 8,
      children: [/*#__PURE__*/_jsx(DharmeshShah, {
        avatarSize: 250
      }), /*#__PURE__*/_jsx(CUIImage, {
        src: seperatedCircleIllustration,
        "aria-hidden": true,
        flexGrow: "1",
        width: "71px",
        alignSelf: "end",
        marginRight: 8
      })]
    }), /*#__PURE__*/_jsxs(CUIFlex, {
      direction: "column",
      gap: 8,
      children: [/*#__PURE__*/_jsxs(CUIFlex, {
        gap: 8,
        children: [/*#__PURE__*/_jsx(CUIImage, {
          src: starsIllustration,
          "aria-hidden": true,
          width: "60px",
          alignSelf: "flex-start",
          marginTop: 8
        }), /*#__PURE__*/_jsx(KieranFlanagan, {
          avatarSize: 160
        })]
      }), /*#__PURE__*/_jsx(AliSchwanke, {
        avatarSize: 125
      })]
    }), /*#__PURE__*/_jsxs(CUIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(CUIImage, {
        src: overlappingCircleIllustration,
        "aria-hidden": true,
        width: "71px",
        flexGrow: "1",
        alignSelf: "center"
      }), /*#__PURE__*/_jsx(KyleJepson, {
        avatarSize: 170
      })]
    }), /*#__PURE__*/_jsxs(CUIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(KatherineBoyarsky, {
        avatarSize: 220
      }), /*#__PURE__*/_jsx(CUIImage, {
        src: starsIllustration,
        "aria-hidden": true,
        width: "60px",
        flexGrow: "1",
        alignSelf: "center"
      })]
    })]
  });
}